// extracted by mini-css-extract-plugin
module.exports = {"term":"Term_term__3JAPW","mid":"Term_mid__2awqA"};